module.exports = __webpack_public_path__ + "zoom2.svg";